import React from "react";
import { Modal } from "antd";

const RestoreArchivedInspectionSessionModal = ({ restoreArchivedSessionModalVisible, toggleModal, sessionID, archiveInspectionSession }) => {
    const title = `Restore Archived Inspection Session #${sessionID}`;

    const handleOk = () => {
        archiveInspectionSession(0);
        toggleModal();
    };

    const handleCancel = () => {
        toggleModal();
    };

    return (
        <Modal
            title={title}
            visible={restoreArchivedSessionModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            width={"40%"}>
            <div className="inspectRail__Modal">This will restore the archived session - do you want to continue?</div>
        </Modal>
    );
};

export default RestoreArchivedInspectionSessionModal;
